import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import cn from "classnames";

import CustomCell from "./CustomCell/CustomCell";

import { setSortStateEditableTable } from "../../../../redux/editableTableReducer/actionEditableTable";

import styles from "./editableTableForKnoweledgeTest.module.css";

function EditableTableForKnoweledgeTest({
  mode,
  columns,
  handleTableDataUpdate,
  tableData,
  caption,
  tableClick = undefined,
  isSmall = false,
  modalData = undefined,
}) {
  const dispatch = useDispatch();
  const [editingCell, setEditingCell] = useState(null); // Состояние для отслеживания редактируемой ячейки
  const [selectedRows, setSelectedRows] = useState(null);
  const [paginationState, setPaginationState] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const { sortState } = useSelector((state) => state.editableTableReducer);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    state: { pageIndex, pageSize, sortBy },
  } = useTable(
    {
      columns,
      data: tableData,
      initialState: { ...paginationState, sortBy: sortState },
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    dispatch(setSortStateEditableTable(sortBy));
  }, [sortBy]);

  useEffect(() => {
    setPaginationState({ pageIndex, pageSize });
  }, [pageIndex, pageSize]);

  const startEditing = (cell) => {
    setEditingCell({
      row: cell.row.index,
      column: cell.column.id,
      editable: cell.column.editable,
      typeEdit: cell.column.typeEdit,
      selectOptions: cell.column.selectOptions,
    });
  };

  const stopEditing = () => {
    const newData = tableData.map((row) => {
      let rowError = false;

      if (row.startDate && new Date(row.startDate.split(".").reverse().join("-")) > new Date()) {
        row.startDate = row.startDate + " Дата не может быть больше текущей";
        rowError = true;
      }

      if (row.endDate && new Date(row.endDate.split(".").reverse().join("-")) > new Date()) {
        row.endDate = row.endDate + " Дата не может быть больше текущей";
        rowError = true;
      }

      if (row.startDate && row.endDate) {
        if (
          new Date(
            row.startDate.length > 10
              ? row.startDate.split(" ")[0].split(".").reverse().join("-")
              : row.startDate.split(".").reverse().join("-"),
          ) >
          new Date(
            row.endDate.length > 10
              ? row.endDate.split(" ")[0].split(".").reverse().join("-")
              : row.endDate.split(".").reverse().join("-"),
          )
        ) {
          row.startDate =
            row.startDate.length > 10
              ? row.startDate
              : row.startDate + " Дата начала не может быть больше даты окончания";
          rowError = true;
        } else {
          row.startDate = row.startDate.split(" ")[0];
        }
      }

      if (row.docDateCertificate && row.endDate) {
        if (
          new Date(
            row.docDateCertificate.length > 10
              ? row.docDateCertificate.split(" ")[0].split(".").reverse().join("-")
              : row.docDateCertificate.split(".").reverse().join("-"),
          ) <
          new Date(
            row.endDate.length > 10
              ? row.endDate.split(" ")[0].split(".").reverse().join("-")
              : row.endDate.split(".").reverse().join("-"),
          )
        ) {
          row.docDateCertificate = row.docDateCertificate + " Дата не может быть меньше даты окончания";
          rowError = true;
        } else {
          row.docDateCertificate = row.docDateCertificate.split(" ")[0];
        }
      }

      row.error = rowError;

      return row;
    });

    handleTableDataUpdate(newData);

    setEditingCell(null);
  };

  const updateData = (event, row, cell, type) => {
    let valueForData = event.target.value;
    let newData = {};
    if (type === "text") {
      newData = { [cell.column.id]: valueForData };
    }
    if (type === "date") {
      const [year, month, day] = valueForData.split("-");
      valueForData = `${day}.${month}.${year}`;
      newData = { [cell.column.id]: valueForData };
    }
    if (type === "select") {
      const options = event.target.options;
      const id = valueForData;
      for (const option of options) {
        if (option.value === id) {
          valueForData = option.text;
        }
      }
      newData = { [cell.column.id]: valueForData, [cell.column.id + "Id"]: id };
    }
    if (type === "checkbox") {
      valueForData = event.target.checked;
      newData = { [cell.column.id]: valueForData };
    }
    if (type === "button") {
      const deletedData = tableData.filter((rowData) => rowData.id !== row.original.id);
      handleTableDataUpdate(deletedData);
      return;
    }
    const data = tableData.map((rowData) => {
      if (rowData.id === row.original.id && rowData.apcode === row.original.apcode) {
        return { ...rowData, ...newData };
      }
      return rowData;
    });
    handleTableDataUpdate(data);
  };

  const handleRowClick = (row) => {
    setSelectedRows(row.original);
    tableClick && tableClick(row.original);
  };

  const isSelected = (row) => {
    if (selectedRows) {
      return selectedRows.id === row.original.id;
    }
  };

  const parseValue = (data, type) => {
    if (data) {
      if (type === "date") {
        const [day, month, year] = data.split(".");
        return `${year}-${month}-${day}`;
      } else return data;
    }
  };

  useEffect(() => {
    if (!modalData) setSelectedRows(null);
  }, [modalData]);

  return (
    <>
      <div className={styles["scrollable-table"]}>
        <table
          {...getTableProps()}
          className={`${styles["table-container"]} ${isSmall ? styles["small-font-size"] : ""}`}>
          <caption className={styles.caption}>{caption}</caption>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    style={{
                      display: column.show ? "table-cell" : "none",
                    }}
                    {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    {column.required && mode !== "view" && <span className={styles.red_dot}>*</span>}
                    <span>{column.isSorted ? (column.isSortedDesc ? " ▼" : " ▲") : "  "}</span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            style={{
              fontSize: isSmall ? "12px" : "18px",
            }}
            {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  data-id={row.original.id ? row.original.id : ""}
                  className={cn({
                    [styles.selected]: isSelected(row) && mode !== "add" && mode !== "edit",
                    [styles.red_border]: row.original.error,
                  })}
                  onClick={(e) => {
                    handleRowClick(row);
                  }}>
                  {row.cells.map((cell) => {
                    const isEditing =
                      editingCell &&
                      editingCell.editable &&
                      editingCell.row === row.index &&
                      editingCell.column === cell.column.id;
                    return (
                      <td
                        {...cell.getCellProps()}
                        onClick={() => startEditing(cell)}
                        className={styles["td-table"]}
                        style={{
                          color: cell?.column?.id === "deadline" && row?.original?.isDeadline ? "red" : "",
                        }}>
                        {isEditing && (mode === "add" || mode === "edit") ? (
                          editingCell && editingCell.typeEdit !== "select" ? (
                            <input
                              className={styles["table-input"]}
                              type={editingCell.typeEdit}
                              value={parseValue(cell.value, editingCell.typeEdit)}
                              onChange={(e) => {
                                updateData(e, row, cell, editingCell.typeEdit);
                              }}
                              onBlur={stopEditing}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  stopEditing();
                                }
                              }}
                            />
                          ) : (
                            <Form.Select
                              data-id={editingCell.column}
                              onChange={(e) => updateData(e, row, cell, editingCell.typeEdit)}
                              onBlur={stopEditing}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  stopEditing();
                                }
                              }}>
                              {editingCell.selectOptions.map((el) => (
                                <option
                                  selected={el.selected}
                                  value={el.id}
                                  disabled={el.disabled}
                                  hidden={el.hidden}>
                                  {el.value}
                                </option>
                              ))}
                            </Form.Select>
                          )
                        ) : cell.column.viewType === "text" || mode !== "add" ? (
                          <CustomCell cell={cell} />
                        ) : cell.column.viewType === "button" ? (
                          <div
                            className={styles["delete-button-block"]}
                            onClick={(e) => updateData(e, row, cell, cell.column.viewType)}>
                            <span
                              className={styles["delete-button"]}
                              onClick={(e) => updateData(e, row, cell, cell.column.viewType)}></span>
                          </div>
                        ) : (
                          <input
                            type={cell.column.viewType}
                            onChange={(e) => updateData(e, row, cell, cell.column.viewType)}
                            checked={cell.value || false}
                            className={`${styles[cell.column.style]} ${
                              cell.column.viewType === "checkbox" && styles["checkbox-input"]
                            }`}
                            disabled={
                              row.original.hasOwnProperty("canChange") ? !row.original.canChange : false
                            }
                            readOnly={
                              row.original.hasOwnProperty("canChange") ? !row.original.canChange : false
                            }
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {tableData.length > 0 && pageOptions.length > 1 && (
        <div className={styles["pagination"]}>
          <button
            className={styles["pagination-button"]}
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}>
            {"<<"}
          </button>
          <button
            className={styles["pagination-button"]}
            onClick={() => previousPage()}
            disabled={!canPreviousPage}>
            {"<"}
          </button>
          {pageOptions.map((page, i) =>
            i < pageIndex + 2 && i > pageIndex - 2 ? (
              <button
                className={styles["pagination-button"]}
                key={i}
                onClick={() => gotoPage(i)}
                style={{
                  fontWeight: pageIndex === i ? "bold" : "normal",
                  color: pageIndex === i ? "white" : "black",
                  backgroundColor: pageIndex === i ? "#BC8653" : "white",
                }}>
                {i + 1}
              </button>
            ) : null,
          )}
          <button
            className={styles["pagination-button"]}
            onClick={() => nextPage()}
            disabled={!canNextPage}>
            {">"}
          </button>
          <button
            className={styles["pagination-button"]}
            onClick={() => gotoPage(pageOptions.length - 1)}
            disabled={!canNextPage}>
            {">>"}
          </button>
        </div>
      )}
    </>
  );
}

export default EditableTableForKnoweledgeTest;
